const MICROSOFT_STORE_BASE_URL =
  "https://apps.microsoft.com/store/detail/9N4Z3Q5N10QR";

export type StorePlacement =
  | "home_hero"
  | "home_workflow"
  | "home_footer"
  | "download_page"
  | "features_page"
  | "youtube_rankings"
  | "ai_shorts_page"
  | "marketing_video_page"
  | "updates_page";

type MetaPixelFunction = (
  action: "trackCustom",
  eventName: string,
  parameters: Record<string, string>,
) => void;

declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    autovidStaticHydrating?: boolean;
  }
}

function sanitizeCampaignPart(value: string | null): string | null {
  if (!value) {
    return null;
  }

  const sanitized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 40);

  return sanitized || null;
}

function getCampaignId(placement: StorePlacement): string {
  if (typeof window === "undefined" || window.autovidStaticHydrating) {
    return `autovid_web_${placement}`;
  }

  const query = new URLSearchParams(window.location.search);
  const campaignParts = [
    "autovid",
    sanitizeCampaignPart(query.get("utm_source")) || "web",
    sanitizeCampaignPart(query.get("utm_campaign")),
    sanitizeCampaignPart(query.get("utm_content")),
    placement,
  ].filter((part): part is string => Boolean(part));

  return campaignParts.join("_").slice(0, 120);
}

export function getMicrosoftStoreUrl(placement: StorePlacement): string {
  const url = new URL(MICROSOFT_STORE_BASE_URL);
  url.searchParams.set("cid", getCampaignId(placement));
  return url.toString();
}

export function trackMicrosoftStoreClick(placement: StorePlacement): void {
  const campaignId = getCampaignId(placement);

  window.dispatchEvent(
    new CustomEvent("autovid-marketing-event", {
      detail: {
        event: "microsoft_store_click",
        campaignId,
        placement,
      },
    }),
  );

  window.fbq?.("trackCustom", "MicrosoftStoreClick", {
    campaign_id: campaignId,
    placement,
  });
}
